exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sidebar{position:absolute;top:0;bottom:0;left:-306px;display:-ms-flexbox;display:flex;width:306px;-webkit-transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;-o-transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;transition:all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;overflow:auto;background-color:#fff;-webkit-box-shadow:rgba(0,0,0,0.12) 0px 1px 6px,rgba(0,0,0,0.12) 0px 1px 4px;box-shadow:rgba(0,0,0,0.12) 0px 1px 6px,rgba(0,0,0,0.12) 0px 1px 4px;z-index:100}.sidebar.open{left:0}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/Sidebar/style.scss
// module id = 1186
// module chunks = 0